module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/nuoro.68298aee87fa4359535c208fc9d3aab7.jpg";